export const ALLOWED_EXTENSIONS = '.pdf,.doc,.docx,.xls,.xlsx';

const ALLOWED_EXTENSION_VALUES = new Set(['pdf', 'doc', 'docx', 'xls', 'xlsx']);

export const ALLOWED_MIME_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]);

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export function isAllowedDocumentFile(file: File): boolean {
  if (ALLOWED_MIME_TYPES.has(file.type)) {
    return true;
  }

  const extension = file.name.toLowerCase().split('.').pop();
  return extension ? ALLOWED_EXTENSION_VALUES.has(extension) : false;
}
